import { render } from "./Repair.vue?vue&type=template&id=244c2bf0&scoped=true"
import script from "./Repair.vue?vue&type=script&lang=js"
export * from "./Repair.vue?vue&type=script&lang=js"

import "./Repair.vue?vue&type=style&index=0&id=244c2bf0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-244c2bf0"

export default script